import { Component, OnInit } from '@angular/core';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import jwt_decode from "jwt-decode";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})

export class NavigationComponent implements OnInit {
  user: any;
  ngOnInit(): void {
    try{
      this.user = jwt_decode(JSON.parse(localStorage.getItem(LocalStorageKeyEnum.USER)));
      let foto = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.PHOTO));
      if(foto){
        this.user['picture'] = foto.changingThisBreaksApplicationSecurity;
      }
      if(!this.user['picture']){
        this.user['picture'] = 'assets/img/default-user.png';
      }
        
    }catch(e) {
      console.log(e)
    }
  }
}
